
import React from 'react';
import { images} from '../../constants';
import {motion} from 'framer-motion'


const AboutUs = () => (
  <div className='relative w-full m-h-screen flex justify-center items-center bg-[#3C2317]' id='about'>
  {/* <img src={images.bg} alt=""  className='w-full h-[192vh] -z-[2] sm:w-full absolute top-0 right-0 left-0 bottom-0 px-4'/> */}
  <div className="m-auto w-[80%] py-20 flex flex-col justify-between items-center mb-32 sm:flex-row relative  gap-2 mt-36 " >

    <div className='w-52 absolute left-10 top-[40%] sm:left-36 md:left-72 sm:right-4 right-6 -z-[1]  '>
        <img src={images.G} alt="g letter" className='w-full'  />
    </div>
    <div className='place-items-center flex flex-col sm:flex-row items-center justify-between gap-8'>
        <motion.div
         whileInView={{x: [-100, 0], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
         className=' text-right'>
            <h1 className='mb-4  text-right font-semibold md:text-6xl text-4xl text-yellow-200 font-main w-full'>About Us</h1>
            <div className="text-right flex justify-end">
            <img src={images.spoon} alt='about_spoon' className='spoon__img block text-right' />

            </div>
            <p className='text-right mb-4 text-white text-base p__opensans w-full'>We are your kitchen away from home,we bring you the best dishes from across the world.</p>
            <button type='button' className='custom__button'>Know More</button>
        </motion.div>

        <motion.div
         whileInView={{y: [-100, 0], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
         className='app__aboutus-content_knife flex__center mt-7'>
          <img src={images.knife} alt='about_knife' className='h-96 w-24 object-contain'/>
        </motion.div>

        <motion.div
         whileInView={{x: [100, 0], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
         className='app__aboutus-conent_history'>
            <h1 className='font-main text-yellow-200 md:text-6xl text-4xl font-semibold mb-4'>Our History</h1>
            <img src={images.spoon} alt='about_spoon' className='spoon__img' />
            <p className='p__opensans mb-4'>We have been giving people the best of meals for ages, with recipes that have been cultured and mastered through time.</p>
            <button type='button' className='custom__button'>Know More</button>
        </motion.div>
    </div>
  </div>
  </div>
);

export default AboutUs;
